export default [
  {
    name: '(GMT-11:00) Niue',
    value: 'Pacific/Niue',
  },
  {
    name: '(GMT-11:00) Pago Pago',
    value: 'Pacific/Pago_Pago',
  },
  {
    name: '(GMT-10:00) Hawaii Time',
    value: 'Pacific/Honolulu',
  },
  {
    name: '(GMT-10:00) Rarotonga',
    value: 'Pacific/Rarotonga',
  },
  {
    name: '(GMT-10:00) Tahiti',
    value: 'Pacific/Tahiti',
  },
  {
    name: '(GMT-09:30) Marquesas',
    value: 'Pacific/Marquesas',
  },
  {
    name: '(GMT-09:00) Alaska Time',
    value: 'America/Anchorage',
  },
  {
    name: '(GMT-09:00) Gambier',
    value: 'Pacific/Gambier',
  },
  {
    name: '(GMT-08:00) Pacific Time',
    value: 'America/Los_Angeles',
  },
  {
    name: '(GMT-08:00) Pacific Time - Tijuana',
    value: 'America/Tijuana',
  },
  {
    name: '(GMT-08:00) Pacific Time - Vancouver',
    value: 'America/Vancouver',
  },
  {
    name: '(GMT-08:00) Pacific Time - Whitehorse',
    value: 'America/Whitehorse',
  },
  {
    name: '(GMT-08:00) Pitcairn',
    value: 'Pacific/Pitcairn',
  },
  {
    name: '(GMT-07:00) Mountain Time - Dawson Creek',
    value: 'America/Dawson_Creek',
  },
  {
    name: '(GMT-07:00) Mountain Time',
    value: 'America/Denver',
  },
  {
    name: '(GMT-07:00) Mountain Time - Edmonton',
    value: 'America/Edmonton',
  },
  {
    name: '(GMT-07:00) Mountain Time - Hermosillo',
    value: 'America/Hermosillo',
  },
  {
    name: '(GMT-07:00) Mountain Time - Chihuahua, Mazatlan',
    value: 'America/Mazatlan',
  },
  {
    name: '(GMT-07:00) Mountain Time - Arizona',
    value: 'America/Phoenix',
  },
  {
    name: '(GMT-07:00) Mountain Time - Yellowknife',
    value: 'America/Yellowknife',
  },
  {
    name: '(GMT-06:00) Belize',
    value: 'America/Belize',
  },
  {
    name: '(GMT-06:00) Central Time',
    value: 'America/Chicago',
  },
  {
    name: '(GMT-06:00) Costa Rica',
    value: 'America/Costa_Rica',
  },
  {
    name: '(GMT-06:00) El Salvador',
    value: 'America/El_Salvador',
  },
  {
    name: '(GMT-06:00) Guatemala',
    value: 'America/Guatemala',
  },
  {
    name: '(GMT-06:00) Managua',
    value: 'America/Managua',
  },
  {
    name: '(GMT-06:00) Central Time - Mexico City',
    value: 'America/Mexico_City',
  },
  {
    name: '(GMT-06:00) Central Time - Regina',
    value: 'America/Regina',
  },
  {
    name: '(GMT-06:00) Central Time - Tegucigalpa',
    value: 'America/Tegucigalpa',
  },
  {
    name: '(GMT-06:00) Central Time - Winnipeg',
    value: 'America/Winnipeg',
  },
  {
    name: '(GMT-06:00) Galapagos',
    value: 'Pacific/Galapagos',
  },
  {
    name: '(GMT-05:00) Bogota',
    value: 'America/Bogota',
  },
  {
    name: '(GMT-05:00) America Cancun',
    value: 'America/Cancun',
  },
  {
    name: '(GMT-05:00) Cayman',
    value: 'America/Cayman',
  },
  {
    name: '(GMT-05:00) Guayaquil',
    value: 'America/Guayaquil',
  },
  {
    name: '(GMT-05:00) Havana',
    value: 'America/Havana',
  },
  {
    name: '(GMT-05:00) Eastern Time - Iqaluit',
    value: 'America/Iqaluit',
  },
  {
    name: '(GMT-05:00) Jamaica',
    value: 'America/Jamaica',
  },
  {
    name: '(GMT-05:00) Lima',
    value: 'America/Lima',
  },
  {
    name: '(GMT-05:00) Nassau',
    value: 'America/Nassau',
  },
  {
    name: '(GMT-05:00) Eastern Time',
    value: 'America/New_York',
  },
  {
    name: '(GMT-05:00) Panama',
    value: 'America/Panama',
  },
  {
    name: '(GMT-05:00) Port-au-Prince',
    value: 'America/Port-au-Prince',
  },
  {
    name: '(GMT-05:00) Rio Branco',
    value: 'America/Rio_Branco',
  },
  {
    name: '(GMT-05:00) Eastern Time - Toronto',
    value: 'America/Toronto',
  },
  {
    name: '(GMT-05:00) Easter Island',
    value: 'Pacific/Easter',
  },
  {
    name: '(GMT-04:30) Caracas',
    value: 'America/Caracas',
  },
  {
    name: '(GMT-03:00) Asuncion',
    value: 'America/Asuncion',
  },
  {
    name: '(GMT-04:00) Barbados',
    value: 'America/Barbados',
  },
  {
    name: '(GMT-04:00) Boa Vista',
    value: 'America/Boa_Vista',
  },
  {
    name: '(GMT-03:00) Campo Grande',
    value: 'America/Campo_Grande',
  },
  {
    name: '(GMT-03:00) Cuiaba',
    value: 'America/Cuiaba',
  },
  {
    name: '(GMT-04:00) Curacao',
    value: 'America/Curacao',
  },
  {
    name: '(GMT-04:00) Grand Turk',
    value: 'America/Grand_Turk',
  },
  {
    name: '(GMT-04:00) Guyana',
    value: 'America/Guyana',
  },
  {
    name: '(GMT-04:00) Atlantic Time - Halifax',
    value: 'America/Halifax',
  },
  {
    name: '(GMT-04:00) La Paz',
    value: 'America/La_Paz',
  },
  {
    name: '(GMT-04:00) Manaus',
    value: 'America/Manaus',
  },
  {
    name: '(GMT-04:00) Martinique',
    value: 'America/Martinique',
  },
  {
    name: '(GMT-04:00) Port of Spain',
    value: 'America/Port_of_Spain',
  },
  {
    name: '(GMT-04:00) Porto Velho',
    value: 'America/Porto_Velho',
  },
  {
    name: '(GMT-04:00) Puerto Rico',
    value: 'America/Puerto_Rico',
  },
  {
    name: '(GMT-04:00) Santo Domingo',
    value: 'America/Santo_Domingo',
  },
  {
    name: '(GMT-04:00) Thule',
    value: 'America/Thule',
  },
  {
    name: '(GMT-04:00) Bermuda',
    value: 'Atlantic/Bermuda',
  },
  {
    name: '(GMT-03:30) Newfoundland Time - St. Johns',
    value: 'America/St_Johns',
  },
  {
    name: '(GMT-03:00) Araguaina',
    value: 'America/Araguaina',
  },
  {
    name: '(GMT-03:00) Buenos Aires',
    value: 'America/Argentina/Buenos_Aires',
  },
  {
    name: '(GMT-03:00) Salvador',
    value: 'America/Bahia',
  },
  {
    name: '(GMT-03:00) Belem',
    value: 'America/Belem',
  },
  {
    name: '(GMT-03:00) Cayenne',
    value: 'America/Cayenne',
  },
  {
    name: '(GMT-03:00) Fortaleza',
    value: 'America/Fortaleza',
  },
  {
    name: '(GMT-03:00) Godthab',
    value: 'America/Godthab',
  },
  {
    name: '(GMT-03:00) Maceio',
    value: 'America/Maceio',
  },
  {
    name: '(GMT-03:00) Miquelon',
    value: 'America/Miquelon',
  },
  {
    name: '(GMT-03:00) Montevideo',
    value: 'America/Montevideo',
  },
  {
    name: '(GMT-03:00) Paramaribo',
    value: 'America/Paramaribo',
  },
  {
    name: '(GMT-03:00) Recife',
    value: 'America/Recife',
  },
  {
    name: '(GMT-03:00) Santiago',
    value: 'America/Santiago',
  },
  {
    name: '(GMT-03:00) Sao Paulo',
    value: 'America/Sao_Paulo',
  },
  {
    name: '(GMT-03:00) Palmer',
    value: 'Antarctica/Palmer',
  },
  {
    name: '(GMT-03:00) Rothera',
    value: 'Antarctica/Rothera',
  },
  {
    name: '(GMT-03:00) Stanley',
    value: 'Atlantic/Stanley',
  },
  {
    name: '(GMT-02:00) Noronha',
    value: 'America/Noronha',
  },
  {
    name: '(GMT-02:00) South Georgia',
    value: 'Atlantic/South_Georgia',
  },
  {
    name: '(GMT-01:00) Scoresbysund',
    value: 'America/Scoresbysund',
  },
  {
    name: '(GMT-01:00) Azores',
    value: 'Atlantic/Azores',
  },
  {
    name: '(GMT-01:00) Cape Verde',
    value: 'Atlantic/Cape_Verde',
  },
  {
    name: '(GMT+00:00) Abidjan',
    value: 'Africa/Abidjan',
  },
  {
    name: '(GMT+00:00) Accra',
    value: 'Africa/Accra',
  },
  {
    name: '(GMT+00:00) Bissau',
    value: 'Africa/Bissau',
  },
  {
    name: '(GMT+00:00) Casablanca',
    value: 'Africa/Casablanca',
  },
  {
    name: '(GMT+00:00) El Aaiun',
    value: 'Africa/El_Aaiun',
  },
  {
    name: '(GMT+00:00) Monrovia',
    value: 'Africa/Monrovia',
  },
  {
    name: '(GMT+00:00) Danmarkshavn',
    value: 'America/Danmarkshavn',
  },
  {
    name: '(GMT+00:00) Canary Islands',
    value: 'Atlantic/Canary',
  },
  {
    name: '(GMT+00:00) Faeroe',
    value: 'Atlantic/Faroe',
  },
  {
    name: '(GMT+00:00) Reykjavik',
    value: 'Atlantic/Reykjavik',
  },
  {
    name: '(GMT+00:00) GMT (no daylight saving)',
    value: 'Etc/GMT',
  },
  {
    name: '(GMT+00:00) Dublin',
    value: 'Europe/Dublin',
  },
  {
    name: '(GMT+00:00) Lisbon',
    value: 'Europe/Lisbon',
  },
  {
    name: '(GMT+00:00) London',
    value: 'Europe/London',
  },
  {
    name: '(GMT+01:00) Algiers',
    value: 'Africa/Algiers',
  },
  {
    name: '(GMT+01:00) Ceuta',
    value: 'Africa/Ceuta',
  },
  {
    name: '(GMT+01:00) Lagos',
    value: 'Africa/Lagos',
  },
  {
    name: '(GMT+01:00) Ndjamena',
    value: 'Africa/Ndjamena',
  },
  {
    name: '(GMT+01:00) Tunis',
    value: 'Africa/Tunis',
  },
  {
    name: '(GMT+02:00) Windhoek',
    value: 'Africa/Windhoek',
  },
  {
    name: '(GMT+01:00) Amsterdam',
    value: 'Europe/Amsterdam',
  },
  {
    name: '(GMT+01:00) Andorra',
    value: 'Europe/Andorra',
  },
  {
    name: '(GMT+01:00) Central European Time - Belgrade',
    value: 'Europe/Belgrade',
  },
  {
    name: '(GMT+01:00) Berlin',
    value: 'Europe/Berlin',
  },
  {
    name: '(GMT+01:00) Brussels',
    value: 'Europe/Brussels',
  },
  {
    name: '(GMT+01:00) Budapest',
    value: 'Europe/Budapest',
  },
  {
    name: '(GMT+01:00) Copenhagen',
    value: 'Europe/Copenhagen',
  },
  {
    name: '(GMT+01:00) Gibraltar',
    value: 'Europe/Gibraltar',
  },
  {
    name: '(GMT+01:00) Luxembourg',
    value: 'Europe/Luxembourg',
  },
  {
    name: '(GMT+01:00) Madrid',
    value: 'Europe/Madrid',
  },
  {
    name: '(GMT+01:00) Malta',
    value: 'Europe/Malta',
  },
  {
    name: '(GMT+01:00) Monaco',
    value: 'Europe/Monaco',
  },
  {
    name: '(GMT+01:00) Oslo',
    value: 'Europe/Oslo',
  },
  {
    name: '(GMT+01:00) Paris',
    value: 'Europe/Paris',
  },
  {
    name: '(GMT+01:00) Central European Time - Prague',
    value: 'Europe/Prague',
  },
  {
    name: '(GMT+01:00) Rome',
    value: 'Europe/Rome',
  },
  {
    name: '(GMT+01:00) Stockholm',
    value: 'Europe/Stockholm',
  },
  {
    name: '(GMT+01:00) Tirane',
    value: 'Europe/Tirane',
  },
  {
    name: '(GMT+01:00) Vienna',
    value: 'Europe/Vienna',
  },
  {
    name: '(GMT+01:00) Warsaw',
    value: 'Europe/Warsaw',
  },
  {
    name: '(GMT+01:00) Zurich',
    value: 'Europe/Zurich',
  },
  {
    name: '(GMT+02:00) Cairo',
    value: 'Africa/Cairo',
  },
  {
    name: '(GMT+02:00) Johannesburg',
    value: 'Africa/Johannesburg',
  },
  {
    name: '(GMT+02:00) Maputo',
    value: 'Africa/Maputo',
  },
  {
    name: '(GMT+02:00) Tripoli',
    value: 'Africa/Tripoli',
  },
  {
    name: '(GMT+02:00) Amman',
    value: 'Asia/Amman',
  },
  {
    name: '(GMT+02:00) Beirut',
    value: 'Asia/Beirut',
  },
  {
    name: '(GMT+02:00) Damascus',
    value: 'Asia/Damascus',
  },
  {
    name: '(GMT+02:00) Gaza',
    value: 'Asia/Gaza',
  },
  {
    name: '(GMT+02:00) Jerusalem',
    value: 'Asia/Jerusalem',
  },
  {
    name: '(GMT+02:00) Nicosia',
    value: 'Asia/Nicosia',
  },
  {
    name: '(GMT+02:00) Athens',
    value: 'Europe/Athens',
  },
  {
    name: '(GMT+02:00) Bucharest',
    value: 'Europe/Bucharest',
  },
  {
    name: '(GMT+02:00) Chisinau',
    value: 'Europe/Chisinau',
  },
  {
    name: '(GMT+02:00) Helsinki',
    value: 'Europe/Helsinki',
  },
  {
    name: '(GMT+02:00) Istanbul',
    value: 'Europe/Istanbul',
  },
  {
    name: '(GMT+02:00) Moscow-01 - Kaliningrad',
    value: 'Europe/Kaliningrad',
  },
  {
    name: '(GMT+02:00) Kyiv',
    value: 'Europe/Kyiv',
  },
  {
    name: '(GMT+02:00) Riga',
    value: 'Europe/Riga',
  },
  {
    name: '(GMT+02:00) Sofia',
    value: 'Europe/Sofia',
  },
  {
    name: '(GMT+02:00) Tallinn',
    value: 'Europe/Tallinn',
  },
  {
    name: '(GMT+02:00) Vilnius',
    value: 'Europe/Vilnius',
  },
  {
    name: '(GMT+03:00) Khartoum',
    value: 'Africa/Khartoum',
  },
  {
    name: '(GMT+03:00) Nairobi',
    value: 'Africa/Nairobi',
  },
  {
    name: '(GMT+03:00) Syowa',
    value: 'Antarctica/Syowa',
  },
  {
    name: '(GMT+03:00) Baghdad',
    value: 'Asia/Baghdad',
  },
  {
    name: '(GMT+03:00) Qatar',
    value: 'Asia/Qatar',
  },
  {
    name: '(GMT+03:00) Riyadh',
    value: 'Asia/Riyadh',
  },
  {
    name: '(GMT+03:00) Minsk',
    value: 'Europe/Minsk',
  },
  {
    name: '(GMT+03:00) Moscow+00 - Moscow',
    value: 'Europe/Moscow',
  },
  {
    name: '(GMT+03:30) Tehran',
    value: 'Asia/Tehran',
  },
  {
    name: '(GMT+04:00) Baku',
    value: 'Asia/Baku',
  },
  {
    name: '(GMT+04:00) Dubai',
    value: 'Asia/Dubai',
  },
  {
    name: '(GMT+04:00) Tbilisi',
    value: 'Asia/Tbilisi',
  },
  {
    name: '(GMT+04:00) Yerevan',
    value: 'Asia/Yerevan',
  },
  {
    name: '(GMT+04:00) Moscow+01 - Samara',
    value: 'Europe/Samara',
  },
  {
    name: '(GMT+04:00) Mahe',
    value: 'Indian/Mahe',
  },
  {
    name: '(GMT+04:00) Mauritius',
    value: 'Indian/Mauritius',
  },
  {
    name: '(GMT+04:00) Reunion',
    value: 'Indian/Reunion',
  },
  {
    name: '(GMT+04:30) Kabul',
    value: 'Asia/Kabul',
  },
  {
    name: '(GMT+05:00) Mawson',
    value: 'Antarctica/Mawson',
  },
  {
    name: '(GMT+05:00) Aqtau',
    value: 'Asia/Aqtau',
  },
  {
    name: '(GMT+05:00) Aqtobe',
    value: 'Asia/Aqtobe',
  },
  {
    name: '(GMT+05:00) Ashgabat',
    value: 'Asia/Ashgabat',
  },
  {
    name: '(GMT+05:00) Dushanbe',
    value: 'Asia/Dushanbe',
  },
  {
    name: '(GMT+05:00) Karachi',
    value: 'Asia/Karachi',
  },
  {
    name: '(GMT+05:00) Tashkent',
    value: 'Asia/Tashkent',
  },
  {
    name: '(GMT+05:00) Moscow+02 - Yekaterinburg',
    value: 'Asia/Yekaterinburg',
  },
  {
    name: '(GMT+05:00) Kerguelen',
    value: 'Indian/Kerguelen',
  },
  {
    name: '(GMT+05:00) Maldives',
    value: 'Indian/Maldives',
  },
  {
    name: '(GMT+05:30) India Standard Time',
    value: 'Asia/Calcutta',
  },
  {
    name: '(GMT+05:30) Colombo',
    value: 'Asia/Colombo',
  },
  {
    name: '(GMT+05:45) Katmandu',
    value: 'Asia/Katmandu',
  },
  {
    name: '(GMT+06:00) Vostok',
    value: 'Antarctica/Vostok',
  },
  {
    name: '(GMT+06:00) Almaty',
    value: 'Asia/Almaty',
  },
  {
    name: '(GMT+06:00) Bishkek',
    value: 'Asia/Bishkek',
  },
  {
    name: '(GMT+06:00) Dhaka',
    value: 'Asia/Dhaka',
  },
  {
    name: '(GMT+06:00) Moscow+03 - Omsk, Novosibirsk',
    value: 'Asia/Omsk',
  },
  {
    name: '(GMT+06:00) Thimphu',
    value: 'Asia/Thimphu',
  },
  {
    name: '(GMT+06:00) Chagos',
    value: 'Indian/Chagos',
  },
  {
    name: '(GMT+06:30) Rangoon',
    value: 'Asia/Rangoon',
  },
  {
    name: '(GMT+06:30) Cocos',
    value: 'Indian/Cocos',
  },
  {
    name: '(GMT+07:00) Davis',
    value: 'Antarctica/Davis',
  },
  {
    name: '(GMT+07:00) Bangkok',
    value: 'Asia/Bangkok',
  },
  {
    name: '(GMT+07:00) Hovd',
    value: 'Asia/Hovd',
  },
  {
    name: '(GMT+07:00) Jakarta',
    value: 'Asia/Jakarta',
  },
  {
    name: '(GMT+07:00) Moscow+04 - Krasnoyarsk',
    value: 'Asia/Krasnoyarsk',
  },
  {
    name: '(GMT+07:00) Hanoi',
    value: 'Asia/Saigon',
  },
  {
    name: '(GMT+07:00) Ho Chi Minh',
    value: 'Asia/Ho_Chi_Minh',
  },
  {
    name: '(GMT+07:00) Christmas',
    value: 'Indian/Christmas',
  },
  {
    name: '(GMT+08:00) Casey',
    value: 'Antarctica/Casey',
  },
  {
    name: '(GMT+08:00) Brunei',
    value: 'Asia/Brunei',
  },
  {
    name: '(GMT+08:00) Choibalsan',
    value: 'Asia/Choibalsan',
  },
  {
    name: '(GMT+08:00) Hong Kong',
    value: 'Asia/Hong_Kong',
  },
  {
    name: '(GMT+08:00) Moscow+05 - Irkutsk',
    value: 'Asia/Irkutsk',
  },
  {
    name: '(GMT+08:00) Kuala Lumpur',
    value: 'Asia/Kuala_Lumpur',
  },
  {
    name: '(GMT+08:00) Macau',
    value: 'Asia/Macau',
  },
  {
    name: '(GMT+08:00) Makassar',
    value: 'Asia/Makassar',
  },
  {
    name: '(GMT+08:00) Manila',
    value: 'Asia/Manila',
  },
  {
    name: '(GMT+08:00) China Time - Beijing',
    value: 'Asia/Shanghai',
  },
  {
    name: '(GMT+08:00) Singapore',
    value: 'Asia/Singapore',
  },
  {
    name: '(GMT+08:00) Taipei',
    value: 'Asia/Taipei',
  },
  {
    name: '(GMT+08:00) Ulaanbaatar',
    value: 'Asia/Ulaanbaatar',
  },
  {
    name: '(GMT+08:00) Western Time - Perth',
    value: 'Australia/Perth',
  },
  {
    name: '(GMT+08:30) Pyongyang',
    value: 'Asia/Pyongyang',
  },
  {
    name: '(GMT+09:00) Dili',
    value: 'Asia/Dili',
  },
  {
    name: '(GMT+09:00) Jayapura',
    value: 'Asia/Jayapura',
  },
  {
    name: '(GMT+09:00) Seoul',
    value: 'Asia/Seoul',
  },
  {
    name: '(GMT+09:00) Tokyo',
    value: 'Asia/Tokyo',
  },
  {
    name: '(GMT+09:00) Moscow+06 - Yakutsk',
    value: 'Asia/Yakutsk',
  },
  {
    name: '(GMT+09:00) Palau',
    value: 'Pacific/Palau',
  },
  {
    name: '(GMT+10:30) Central Time - Adelaide',
    value: 'Australia/Adelaide',
  },
  {
    name: '(GMT+09:30) Central Time - Darwin',
    value: 'Australia/Darwin',
  },
  {
    name: "(GMT+10:00) Dumont D'Urville",
    value: 'Antarctica/DumontDUrville',
  },
  {
    name: '(GMT+10:00) Moscow+07 - Magadan',
    value: 'Asia/Magadan',
  },
  {
    name: '(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk',
    value: 'Asia/Vladivostok',
  },
  {
    name: '(GMT+10:00) Eastern Time - Brisbane',
    value: 'Australia/Brisbane',
  },
  {
    name: '(GMT+11:00) Eastern Time - Hobart',
    value: 'Australia/Hobart',
  },
  {
    name: '(GMT+11:00) Eastern Time - Melbourne, Sydney',
    value: 'Australia/Sydney',
  },
  {
    name: '(GMT+10:00) Truk',
    value: 'Pacific/Chuuk',
  },
  {
    name: '(GMT+10:00) Guam',
    value: 'Pacific/Guam',
  },
  {
    name: '(GMT+10:00) Port Moresby',
    value: 'Pacific/Port_Moresby',
  },
  {
    name: '(GMT+11:00) Efate',
    value: 'Pacific/Efate',
  },
  {
    name: '(GMT+11:00) Guadalcanal',
    value: 'Pacific/Guadalcanal',
  },
  {
    name: '(GMT+11:00) Kosrae',
    value: 'Pacific/Kosrae',
  },
  {
    name: '(GMT+11:00) Norfolk',
    value: 'Pacific/Norfolk',
  },
  {
    name: '(GMT+11:00) Noumea',
    value: 'Pacific/Noumea',
  },
  {
    name: '(GMT+11:00) Ponape',
    value: 'Pacific/Pohnpei',
  },
  {
    name: '(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy',
    value: 'Asia/Kamchatka',
  },
  {
    name: '(GMT+13:00) Auckland',
    value: 'Pacific/Auckland',
  },
  {
    name: '(GMT+13:00) Fiji',
    value: 'Pacific/Fiji',
  },
  {
    name: '(GMT+12:00) Funafuti',
    value: 'Pacific/Funafuti',
  },
  {
    name: '(GMT+12:00) Kwajalein',
    value: 'Pacific/Kwajalein',
  },
  {
    name: '(GMT+12:00) Majuro',
    value: 'Pacific/Majuro',
  },
  {
    name: '(GMT+12:00) Nauru',
    value: 'Pacific/Nauru',
  },
  {
    name: '(GMT+12:00) Tarawa',
    value: 'Pacific/Tarawa',
  },
  {
    name: '(GMT+12:00) Wake',
    value: 'Pacific/Wake',
  },
  {
    name: '(GMT+12:00) Wallis',
    value: 'Pacific/Wallis',
  },
  {
    name: '(GMT+14:00) Apia',
    value: 'Pacific/Apia',
  },
  {
    name: '(GMT+13:00) Enderbury',
    value: 'Pacific/Enderbury',
  },
  {
    name: '(GMT+13:00) Fakaofo',
    value: 'Pacific/Fakaofo',
  },
  {
    name: '(GMT+13:00) Tongatapu',
    value: 'Pacific/Tongatapu',
  },
  {
    name: '(GMT+14:00) Kiritimati',
    value: 'Pacific/Kiritimati',
  },
]
